import { Check, ChevronsUpDown } from "lucide-react";
import { Avatar } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCurrentWorkspace } from "@/hooks/useWorkspaceData";
import { useWorkspaceStore } from "@/stores/workspaceStore";
export function FleetSwitcher() {
  const data = useCurrentWorkspace();
  const setWorkspace = useWorkspaceStore((s) => s.setWorkspace);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Workspace: ${data.workspace.name}`}
          className="focus-ring flex h-9 min-w-0 max-w-[min(22rem,53vw)] items-center gap-2 rounded-sm px-1.5 hover:bg-sidebar-accent"
        >
          <Avatar
            name={data.workspace.name}
            size="sm"
            shape="square"
            className="shrink-0 bg-ink text-background"
          />
          <span className="truncate text-sm font-medium text-ink">
            {data.workspace.name}
          </span>
          <ChevronsUpDown className="size-3.5 shrink-0 text-ink-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72">
        <DropdownMenuLabel>Workspaces</DropdownMenuLabel>
        {data.workspaces.map((w) => (
          <DropdownMenuItem
            key={w.id}
            onSelect={() => setWorkspace(w.id)}
            className="h-auto py-2.5"
          >
            <Avatar name={w.name} size="sm" shape="square" />
            <span className="flex-1">{w.name}</span>
            {w.id === data.workspace.id && (
              <Check aria-label="Current workspace" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
